export const redirectToSignInEncoded = () => {
  if (typeof window === 'undefined') return;
  window.location.replace(
    `/auth/view/signin?redirect=${encodeURIComponent(
      window.location.pathname + window.location.search,
    )}`,
  );
};

export const redirectTo = (path: string) => {
  if (typeof window === 'undefined') return;
  window.location.replace(path);
};

export const reloadPage = () => {
  if (typeof window === 'undefined') return;
  window.location.reload();
};
